const ze = 1024;
let xe = 0;
class z {
  constructor(e, t) {
    this.from = e, this.to = t;
  }
}
class C {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = xe++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = T.match(e)), (t) => {
      let r = e(t);
      return r === void 0 ? null : [this, r];
    };
  }
}
C.closedBy = new C({ deserialize: (l) => l.split(" ") });
C.openedBy = new C({ deserialize: (l) => l.split(" ") });
C.group = new C({ deserialize: (l) => l.split(" ") });
C.contextHash = new C({ perNode: !0 });
C.lookAhead = new C({ perNode: !0 });
C.mounted = new C({ perNode: !0 });
class G {
  constructor(e, t, r) {
    this.tree = e, this.overlay = t, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[C.mounted.id];
  }
}
const be = /* @__PURE__ */ Object.create(null);
class T {
  /**
  @internal
  */
  constructor(e, t, r, i = 0) {
    this.name = e, this.props = t, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let t = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : be, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new T(e.name || "", t, e.id, r);
    if (e.props) {
      for (let n of e.props)
        if (Array.isArray(n) || (n = n(i)), n) {
          if (n[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          t[n[0].id] = n[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let t = this.prop(C.group);
      return t ? t.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let i of r.split(" "))
        t[i] = e[r];
    return (r) => {
      for (let i = r.prop(C.group), n = -1; n < (i ? i.length : 0); n++) {
        let s = t[n < 0 ? r.name : i[n]];
        if (s)
          return s;
      }
    };
  }
}
T.none = new T(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class de {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].id != t)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let t = [];
    for (let r of this.types) {
      let i = null;
      for (let n of e) {
        let s = n(r);
        s && (i || (i = Object.assign({}, r.props)), i[s[0].id] = s[1]);
      }
      t.push(i ? new T(r.name, i, r.id, r.flags) : r);
    }
    return new de(t);
  }
}
const Q = /* @__PURE__ */ new WeakMap(), le = /* @__PURE__ */ new WeakMap();
var k;
(function(l) {
  l[l.ExcludeBuffers = 1] = "ExcludeBuffers", l[l.IncludeAnonymous = 2] = "IncludeAnonymous", l[l.IgnoreMounts = 4] = "IgnoreMounts", l[l.IgnoreOverlays = 8] = "IgnoreOverlays";
})(k || (k = {}));
class B {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, t, r, i, n) {
    if (this.type = e, this.children = t, this.positions = r, this.length = i, this.props = null, n && n.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, h] of n)
        this.props[typeof s == "number" ? s : s.id] = h;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = G.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let t = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (t && (t += ","), t += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (t.length ? "(" + t + ")" : "") : t;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new Y(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, t = 0, r = 0) {
    let i = Q.get(this) || this.topNode, n = new Y(i);
    return n.moveTo(e, t), Q.set(this, n._tree), n;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new P(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, t = 0) {
    let r = $(Q.get(this) || this.topNode, e, t, !1);
    return Q.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, t = 0) {
    let r = $(le.get(this) || this.topNode, e, t, !0);
    return le.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, t = 0) {
    return ke(this, e, t);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: t, leave: r, from: i = 0, to: n = this.length } = e, s = e.mode || 0, h = (s & k.IncludeAnonymous) > 0;
    for (let f = this.cursor(s | k.IncludeAnonymous); ; ) {
      let u = !1;
      if (f.from <= n && f.to >= i && (!h && f.type.isAnonymous || t(f) !== !1)) {
        if (f.firstChild())
          continue;
        u = !0;
      }
      for (; u && r && (h || !f.type.isAnonymous) && r(f), !f.nextSibling(); ) {
        if (!f.parent())
          return;
        u = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let t in this.props)
        e.push([+t, this.props[t]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : ie(T.none, this.children, this.positions, 0, this.children.length, 0, this.length, (t, r, i) => new B(this.type, t, r, i, this.propValues), e.makeTree || ((t, r, i) => new B(T.none, t, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return Ce(e);
  }
}
B.empty = new B(T.none, [], [], 0);
class te {
  constructor(e, t) {
    this.buffer = e, this.index = t;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new te(this.buffer, this.index);
  }
}
class U {
  /**
  Create a tree buffer.
  */
  constructor(e, t, r) {
    this.buffer = e, this.length = t, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return T.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let t = 0; t < this.buffer.length; )
      e.push(this.childString(t)), t = this.buffer[t + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let t = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[t], n = i.name;
    if (/\W/.test(n) && !i.isError && (n = JSON.stringify(n)), e += 4, r == e)
      return n;
    let s = [];
    for (; e < r; )
      s.push(this.childString(e)), e = this.buffer[e + 3];
    return n + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, t, r, i, n) {
    let { buffer: s } = this, h = -1;
    for (let f = e; f != t && !(ge(n, i, s[f + 1], s[f + 2]) && (h = f, r > 0)); f = s[f + 3])
      ;
    return h;
  }
  /**
  @internal
  */
  slice(e, t, r) {
    let i = this.buffer, n = new Uint16Array(t - e), s = 0;
    for (let h = e, f = 0; h < t; ) {
      n[f++] = i[h++], n[f++] = i[h++] - r;
      let u = n[f++] = i[h++] - r;
      n[f++] = i[h++] - e, s = Math.max(s, u);
    }
    return new U(n, s, this.set);
  }
}
function ge(l, e, t, r) {
  switch (l) {
    case -2:
      return t < e;
    case -1:
      return r >= e && t < e;
    case 0:
      return t < e && r > e;
    case 1:
      return t <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function $(l, e, t, r) {
  for (var i; l.from == l.to || (t < 1 ? l.from >= e : l.from > e) || (t > -1 ? l.to <= e : l.to < e); ) {
    let s = !r && l instanceof P && l.index < 0 ? null : l.parent;
    if (!s)
      return l;
    l = s;
  }
  let n = r ? 0 : k.IgnoreOverlays;
  if (r)
    for (let s = l, h = s.parent; h; s = h, h = s.parent)
      s instanceof P && s.index < 0 && ((i = h.enter(e, t, n)) === null || i === void 0 ? void 0 : i.from) != s.from && (l = h);
  for (; ; ) {
    let s = l.enter(e, t, n);
    if (!s)
      return l;
    l = s;
  }
}
class me {
  cursor(e = 0) {
    return new Y(this, e);
  }
  getChild(e, t = null, r = null) {
    let i = he(this, e, t, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, t = null, r = null) {
    return he(this, e, t, r);
  }
  resolve(e, t = 0) {
    return $(this, e, t, !1);
  }
  resolveInner(e, t = 0) {
    return $(this, e, t, !0);
  }
  matchContext(e) {
    return Z(this, e);
  }
  enterUnfinishedNodesBefore(e) {
    let t = this.childBefore(e), r = this;
    for (; t; ) {
      let i = t.lastChild;
      if (!i || i.to != t.to)
        break;
      i.type.isError && i.from == i.to ? (r = t, t = i.prevSibling) : t = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class P extends me {
  constructor(e, t, r, i) {
    super(), this._tree = e, this.from = t, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, t, r, i, n = 0) {
    for (let s = this; ; ) {
      for (let { children: h, positions: f } = s._tree, u = t > 0 ? h.length : -1; e != u; e += t) {
        let o = h[e], c = f[e] + s.from;
        if (ge(i, r, c, c + o.length)) {
          if (o instanceof U) {
            if (n & k.ExcludeBuffers)
              continue;
            let a = o.findChild(0, o.buffer.length, t, r - c, i);
            if (a > -1)
              return new O(new we(s, o, e, c), null, a);
          } else if (n & k.IncludeAnonymous || !o.type.isAnonymous || re(o)) {
            let a;
            if (!(n & k.IgnoreMounts) && (a = G.get(o)) && !a.overlay)
              return new P(a.tree, c, e, s);
            let x = new P(o, c, e, s);
            return n & k.IncludeAnonymous || !x.type.isAnonymous ? x : x.nextChild(t < 0 ? o.children.length - 1 : 0, t, r, i);
          }
        }
      }
      if (n & k.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? e = s.index + t : e = t < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, r = 0) {
    let i;
    if (!(r & k.IgnoreOverlays) && (i = G.get(this._tree)) && i.overlay) {
      let n = e - this.from;
      for (let { from: s, to: h } of i.overlay)
        if ((t > 0 ? s <= n : s < n) && (t < 0 ? h >= n : h > n))
          return new P(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, t, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function he(l, e, t, r) {
  let i = l.cursor(), n = [];
  if (!i.firstChild())
    return n;
  if (t != null) {
    for (; !i.type.is(t); )
      if (!i.nextSibling())
        return n;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return n;
    if (i.type.is(e) && n.push(i.node), !i.nextSibling())
      return r == null ? n : [];
  }
}
function Z(l, e, t = e.length - 1) {
  for (let r = l.parent; t >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[t] && e[t] != r.name)
        return !1;
      t--;
    }
  }
  return !0;
}
class we {
  constructor(e, t, r, i) {
    this.parent = e, this.buffer = t, this.index = r, this.start = i;
  }
}
class O extends me {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, t, r) {
    super(), this.context = e, this._parent = t, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, t, r) {
    let { buffer: i } = this.context, n = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.context.start, r);
    return n < 0 ? null : new O(this.context, this, n);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, r = 0) {
    if (r & k.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, n = i.findChild(this.index + 4, i.buffer[this.index + 3], t > 0 ? 1 : -1, e - this.context.start, t);
    return n < 0 ? null : new O(this.context, this, n);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, t = e.buffer[this.index + 3];
    return t < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new O(this.context, this._parent, t) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, t = this._parent ? this._parent.index + 4 : 0;
    return this.index == t ? this.externalSibling(-1) : new O(this.context, this._parent, e.findChild(
      t,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], t = [], { buffer: r } = this.context, i = this.index + 4, n = r.buffer[this.index + 3];
    if (n > i) {
      let s = r.buffer[this.index + 1];
      e.push(r.slice(i, n, s)), t.push(0);
    }
    return new B(this.type, e, t, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function ye(l) {
  if (!l.length)
    return null;
  if (l.length == 1)
    return l[0];
  let e = 0, t = l[0];
  for (let n = 1; n < l.length; n++) {
    let s = l[n];
    (s.from > t.from || s.to < t.to) && (t = s, e = n);
  }
  let r = t instanceof P && t.index < 0 ? null : t.parent, i = l.slice();
  return r ? i[e] = r : i.splice(e, 1), new ve(i, t);
}
class ve {
  constructor(e, t) {
    this.heads = e, this.node = t;
  }
  get next() {
    return ye(this.heads);
  }
}
function ke(l, e, t) {
  let r = l.resolveInner(e, t), i = null;
  for (let n = r instanceof P ? r : r.context.parent; n; n = n.parent)
    if (n.index < 0) {
      let s = n.parent;
      (i || (i = [r])).push(s.resolve(e, t)), n = s;
    } else {
      let s = G.get(n.tree);
      if (s && s.overlay && s.overlay[0].from <= e && s.overlay[s.overlay.length - 1].to >= e) {
        let h = new P(s.tree, s.overlay[0].from + n.from, 0, null);
        (i || (i = [r])).push($(h, e, t, !1));
      }
    }
  return i ? ye(i) : r;
}
class Y {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, t = 0) {
    if (this.mode = t, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof P)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, t) {
    this.index = e;
    let { start: r, buffer: i } = this.buffer;
    return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  yield(e) {
    return e ? e instanceof P ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, t, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, r, this.mode));
    let { buffer: i } = this.buffer, n = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.buffer.start, r);
    return n < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(n));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, t, r = this.mode) {
    return this.buffer ? r & k.ExcludeBuffers ? !1 : this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & k.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & k.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: t } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(t.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = t.buffer[this.index + 3];
      if (i < (r < 0 ? t.buffer.length : t.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let t, r, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let n = 0; n < this.index; n++)
          if (i.buffer.buffer[n + 3] < this.index)
            return !1;
      ({ index: t, parent: r } = i);
    } else
      ({ index: t, _parent: r } = this._tree);
    for (; r; { index: t, _parent: r } = r)
      if (t > -1)
        for (let n = t + e, s = e < 0 ? -1 : r._tree.children.length; n != s; n += e) {
          let h = r._tree.children[n];
          if (this.mode & k.IncludeAnonymous || h instanceof U || !h.type.isAnonymous || re(h))
            return !1;
        }
    return !0;
  }
  move(e, t) {
    if (t && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, t = 0) {
    for (; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, t); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, t = null, r = 0;
    if (e && e.context == this.buffer)
      e:
        for (let i = this.index, n = this.stack.length; n >= 0; ) {
          for (let s = e; s; s = s._parent)
            if (s.index == i) {
              if (i == this.index)
                return s;
              t = s, r = n + 1;
              break e;
            }
          i = this.stack[--n];
        }
    for (let i = r; i < this.stack.length; i++)
      t = new O(this.buffer, t, this.stack[i]);
    return this.bufferNode = new O(this.buffer, t, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, t) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && t && t(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!r)
          return;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return Z(this.node, e);
    let { buffer: t } = this.buffer, { types: r } = t.set;
    for (let i = e.length - 1, n = this.stack.length - 1; i >= 0; n--) {
      if (n < 0)
        return Z(this.node, e, i);
      let s = r[t.buffer[this.stack[n]]];
      if (!s.isAnonymous) {
        if (e[i] && e[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function re(l) {
  return l.children.some((e) => e instanceof U || !e.type.isAnonymous || re(e));
}
function Ce(l) {
  var e;
  let { buffer: t, nodeSet: r, maxBufferLength: i = 1024, reused: n = [], minRepeatType: s = r.types.length } = l, h = Array.isArray(t) ? new te(t, t.length) : t, f = r.types, u = 0, o = 0;
  function c(b, w, p, m, A) {
    let { id: y, start: g, end: v, size: N } = h, M = o;
    for (; N < 0; )
      if (h.next(), N == -1) {
        let W = n[y];
        p.push(W), m.push(g - b);
        return;
      } else if (N == -3) {
        u = y;
        return;
      } else if (N == -4) {
        o = y;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${N}`);
    let J = f[y], L, D, ne = g - b;
    if (v - g <= i && (D = _(h.pos - w, A))) {
      let W = new Uint16Array(D.size - D.skip), E = h.pos - D.size, R = W.length;
      for (; h.pos > E; )
        R = F(D.start, W, R);
      L = new U(W, v - D.start, r), ne = D.start - b;
    } else {
      let W = h.pos - N;
      h.next();
      let E = [], R = [], H = y >= s ? y : -1, V = 0, K = v;
      for (; h.pos > W; )
        H >= 0 && h.id == H && h.size >= 0 ? (h.end <= K - i && (x(E, R, g, V, h.end, K, H, M), V = E.length, K = h.end), h.next()) : c(g, W, E, R, H);
      if (H >= 0 && V > 0 && V < E.length && x(E, R, g, V, g, K, H, M), E.reverse(), R.reverse(), H > -1 && V > 0) {
        let se = a(J);
        L = ie(J, E, R, 0, E.length, 0, v - g, se, se);
      } else
        L = d(J, E, R, v - g, M - v);
    }
    p.push(L), m.push(ne);
  }
  function a(b) {
    return (w, p, m) => {
      let A = 0, y = w.length - 1, g, v;
      if (y >= 0 && (g = w[y]) instanceof B) {
        if (!y && g.type == b && g.length == m)
          return g;
        (v = g.prop(C.lookAhead)) && (A = p[y] + g.length + v);
      }
      return d(b, w, p, m, A);
    };
  }
  function x(b, w, p, m, A, y, g, v) {
    let N = [], M = [];
    for (; b.length > m; )
      N.push(b.pop()), M.push(w.pop() + p - A);
    b.push(d(r.types[g], N, M, y - A, v - y)), w.push(A - p);
  }
  function d(b, w, p, m, A = 0, y) {
    if (u) {
      let g = [C.contextHash, u];
      y = y ? [g].concat(y) : [g];
    }
    if (A > 25) {
      let g = [C.lookAhead, A];
      y = y ? [g].concat(y) : [g];
    }
    return new B(b, w, p, m, y);
  }
  function _(b, w) {
    let p = h.fork(), m = 0, A = 0, y = 0, g = p.end - i, v = { size: 0, start: 0, skip: 0 };
    e:
      for (let N = p.pos - b; p.pos > N; ) {
        let M = p.size;
        if (p.id == w && M >= 0) {
          v.size = m, v.start = A, v.skip = y, y += 4, m += 4, p.next();
          continue;
        }
        let J = p.pos - M;
        if (M < 0 || J < N || p.start < g)
          break;
        let L = p.id >= s ? 4 : 0, D = p.start;
        for (p.next(); p.pos > J; ) {
          if (p.size < 0)
            if (p.size == -3)
              L += 4;
            else
              break e;
          else
            p.id >= s && (L += 4);
          p.next();
        }
        A = D, m += M, y += L;
      }
    return (w < 0 || m == b) && (v.size = m, v.start = A, v.skip = y), v.size > 4 ? v : void 0;
  }
  function F(b, w, p) {
    let { id: m, start: A, end: y, size: g } = h;
    if (h.next(), g >= 0 && m < s) {
      let v = p;
      if (g > 4) {
        let N = h.pos - (g - 4);
        for (; h.pos > N; )
          p = F(b, w, p);
      }
      w[--p] = v, w[--p] = y - b, w[--p] = A - b, w[--p] = m;
    } else
      g == -3 ? u = m : g == -4 && (o = m);
    return p;
  }
  let I = [], j = [];
  for (; h.pos > 0; )
    c(l.start || 0, l.bufferStart || 0, I, j, -1);
  let S = (e = l.length) !== null && e !== void 0 ? e : I.length ? j[0] + I[0].length : 0;
  return new B(f[l.topID], I.reverse(), j.reverse(), S);
}
const fe = /* @__PURE__ */ new WeakMap();
function X(l, e) {
  if (!l.isAnonymous || e instanceof U || e.type != l)
    return 1;
  let t = fe.get(e);
  if (t == null) {
    t = 1;
    for (let r of e.children) {
      if (r.type != l || !(r instanceof B)) {
        t = 1;
        break;
      }
      t += X(l, r);
    }
    fe.set(e, t);
  }
  return t;
}
function ie(l, e, t, r, i, n, s, h, f) {
  let u = 0;
  for (let d = r; d < i; d++)
    u += X(l, e[d]);
  let o = Math.ceil(
    u * 1.5 / 8
    /* Balance.BranchFactor */
  ), c = [], a = [];
  function x(d, _, F, I, j) {
    for (let S = F; S < I; ) {
      let b = S, w = _[S], p = X(l, d[S]);
      for (S++; S < I; S++) {
        let m = X(l, d[S]);
        if (p + m >= o)
          break;
        p += m;
      }
      if (S == b + 1) {
        if (p > o) {
          let m = d[b];
          x(m.children, m.positions, 0, m.children.length, _[b] + j);
          continue;
        }
        c.push(d[b]);
      } else {
        let m = _[S - 1] + d[S - 1].length - w;
        c.push(ie(l, d, _, b, S, w, m, null, f));
      }
      a.push(w + j - n);
    }
  }
  return x(e, t, r, i, 0), (h || f)(c, a, s);
}
class Me {
  constructor() {
    this.map = /* @__PURE__ */ new WeakMap();
  }
  setBuffer(e, t, r) {
    let i = this.map.get(e);
    i || this.map.set(e, i = /* @__PURE__ */ new Map()), i.set(t, r);
  }
  getBuffer(e, t) {
    let r = this.map.get(e);
    return r && r.get(t);
  }
  /**
  Set the value for this syntax node.
  */
  set(e, t) {
    e instanceof O ? this.setBuffer(e.context.buffer, e.index, t) : e instanceof P && this.map.set(e.tree, t);
  }
  /**
  Retrieve value for this syntax node, if it exists in the map.
  */
  get(e) {
    return e instanceof O ? this.getBuffer(e.context.buffer, e.index) : e instanceof P ? this.map.get(e.tree) : void 0;
  }
  /**
  Set the value for the node that a cursor currently points to.
  */
  cursorSet(e, t) {
    e.buffer ? this.setBuffer(e.buffer.buffer, e.index, t) : this.map.set(e.tree, t);
  }
  /**
  Retrieve the value for the node that a cursor currently points
  to.
  */
  cursorGet(e) {
    return e.buffer ? this.getBuffer(e.buffer.buffer, e.index) : this.map.get(e.tree);
  }
}
class q {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, t, r, i, n = !1, s = !1) {
    this.from = e, this.to = t, this.tree = r, this.offset = i, this.open = (n ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, t = [], r = !1) {
    let i = [new q(0, e.length, e, 0, !1, r)];
    for (let n of t)
      n.to > e.length && i.push(n);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, t, r = 128) {
    if (!t.length)
      return e;
    let i = [], n = 1, s = e.length ? e[0] : null;
    for (let h = 0, f = 0, u = 0; ; h++) {
      let o = h < t.length ? t[h] : null, c = o ? o.fromA : 1e9;
      if (c - f >= r)
        for (; s && s.from < c; ) {
          let a = s;
          if (f >= a.from || c <= a.to || u) {
            let x = Math.max(a.from, f) - u, d = Math.min(a.to, c) - u;
            a = x >= d ? null : new q(x, d, a.tree, a.offset + u, h > 0, !!o);
          }
          if (a && i.push(a), s.to > c)
            break;
          s = n < e.length ? e[n++] : null;
        }
      if (!o)
        break;
      f = o.toA, u = o.toA - o.toB;
    }
    return i;
  }
}
class Ee {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, t, r) {
    return typeof e == "string" && (e = new Ae(e)), r = r ? r.length ? r.map((i) => new z(i.from, i.to)) : [new z(0, 0)] : [new z(0, e.length)], this.createParse(e, t || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, t, r) {
    let i = this.startParse(e, t, r);
    for (; ; ) {
      let n = i.advance();
      if (n)
        return n;
    }
  }
}
class Ae {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, t) {
    return this.string.slice(e, t);
  }
}
function Te(l) {
  return (e, t, r, i) => new _e(e, l, t, r, i);
}
class oe {
  constructor(e, t, r, i, n) {
    if (this.parser = e, this.parse = t, this.overlay = r, this.target = i, this.ranges = n, !n.length || n.some((s) => s.from >= s.to))
      throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(n));
  }
}
class Se {
  constructor(e, t, r, i, n, s, h) {
    this.parser = e, this.predicate = t, this.mounts = r, this.index = i, this.start = n, this.target = s, this.prev = h, this.depth = 0, this.ranges = [];
  }
}
const ee = new C({ perNode: !0 });
class _e {
  constructor(e, t, r, i, n) {
    this.nest = t, this.input = r, this.fragments = i, this.ranges = n, this.inner = [], this.innerDone = 0, this.baseTree = null, this.stoppedAt = null, this.baseParse = e;
  }
  advance() {
    if (this.baseParse) {
      let r = this.baseParse.advance();
      if (!r)
        return null;
      if (this.baseParse = null, this.baseTree = r, this.startInner(), this.stoppedAt != null)
        for (let i of this.inner)
          i.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let r = this.baseTree;
      return this.stoppedAt != null && (r = new B(r.type, r.children, r.positions, r.length, r.propValues.concat([[ee, this.stoppedAt]]))), r;
    }
    let e = this.inner[this.innerDone], t = e.parse.advance();
    if (t) {
      this.innerDone++;
      let r = Object.assign(/* @__PURE__ */ Object.create(null), e.target.props);
      r[C.mounted.id] = new G(t, e.overlay, e.parser), e.target.props = r;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let e = this.input.length;
    for (let t = this.innerDone; t < this.inner.length; t++)
      this.inner[t].ranges[0].from < e && (e = Math.min(e, this.inner[t].parse.parsedPos));
    return e;
  }
  stopAt(e) {
    if (this.stoppedAt = e, this.baseParse)
      this.baseParse.stopAt(e);
    else
      for (let t = this.innerDone; t < this.inner.length; t++)
        this.inner[t].parse.stopAt(e);
  }
  startInner() {
    let e = new Be(this.fragments), t = null, r = null, i = new Y(new P(this.baseTree, this.ranges[0].from, 0, null), k.IncludeAnonymous | k.IgnoreMounts);
    e:
      for (let n, s; this.stoppedAt == null || i.from < this.stoppedAt; ) {
        let h = !0, f;
        if (e.hasNode(i)) {
          if (t) {
            let u = t.mounts.find((o) => o.frag.from <= i.from && o.frag.to >= i.to && o.mount.overlay);
            if (u)
              for (let o of u.mount.overlay) {
                let c = o.from + u.pos, a = o.to + u.pos;
                c >= i.from && a <= i.to && !t.ranges.some((x) => x.from < a && x.to > c) && t.ranges.push({ from: c, to: a });
              }
          }
          h = !1;
        } else if (r && (s = Pe(r.ranges, i.from, i.to)))
          h = s != 2;
        else if (!i.type.isAnonymous && i.from < i.to && (n = this.nest(i, this.input))) {
          i.tree || Ne(i);
          let u = e.findMounts(i.from, n.parser);
          if (typeof n.overlay == "function")
            t = new Se(n.parser, n.overlay, u, this.inner.length, i.from, i.tree, t);
          else {
            let o = pe(this.ranges, n.overlay || [new z(i.from, i.to)]);
            o.length && this.inner.push(new oe(n.parser, n.parser.startParse(this.input, ce(u, o), o), n.overlay ? n.overlay.map((c) => new z(c.from - i.from, c.to - i.from)) : null, i.tree, o)), n.overlay ? o.length && (r = { ranges: o, depth: 0, prev: r }) : h = !1;
          }
        } else
          t && (f = t.predicate(i)) && (f === !0 && (f = new z(i.from, i.to)), f.from < f.to && t.ranges.push(f));
        if (h && i.firstChild())
          t && t.depth++, r && r.depth++;
        else
          for (; !i.nextSibling(); ) {
            if (!i.parent())
              break e;
            if (t && !--t.depth) {
              let u = pe(this.ranges, t.ranges);
              u.length && this.inner.splice(t.index, 0, new oe(t.parser, t.parser.startParse(this.input, ce(t.mounts, u), u), t.ranges.map((o) => new z(o.from - t.start, o.to - t.start)), t.target, u)), t = t.prev;
            }
            r && !--r.depth && (r = r.prev);
          }
      }
  }
}
function Pe(l, e, t) {
  for (let r of l) {
    if (r.from >= t)
      break;
    if (r.to > e)
      return r.from <= e && r.to >= t ? 2 : 1;
  }
  return 0;
}
function ue(l, e, t, r, i, n) {
  if (e < t) {
    let s = l.buffer[e + 1];
    r.push(l.slice(e, t, s)), i.push(s - n);
  }
}
function Ne(l) {
  let { node: e } = l, t = 0;
  do
    l.parent(), t++;
  while (!l.tree);
  let r = 0, i = l.tree, n = 0;
  for (; n = i.positions[r] + l.from, !(n <= e.from && n + i.children[r].length >= e.to); r++)
    ;
  let s = i.children[r], h = s.buffer;
  function f(u, o, c, a, x) {
    let d = u;
    for (; h[d + 2] + n <= e.from; )
      d = h[d + 3];
    let _ = [], F = [];
    ue(s, u, d, _, F, a);
    let I = h[d + 1], j = h[d + 2], S = I + n == e.from && j + n == e.to && h[d] == e.type.id;
    return _.push(S ? e.toTree() : f(d + 4, h[d + 3], s.set.types[h[d]], I, j - I)), F.push(I - a), ue(s, h[d + 3], o, _, F, a), new B(c, _, F, x);
  }
  i.children[r] = f(0, h.length, T.none, 0, s.length);
  for (let u = 0; u <= t; u++)
    l.childAfter(e.from);
}
class ae {
  constructor(e, t) {
    this.offset = t, this.done = !1, this.cursor = e.cursor(k.IncludeAnonymous | k.IgnoreMounts);
  }
  // Move to the first node (in pre-order) that starts at or after `pos`.
  moveTo(e) {
    let { cursor: t } = this, r = e - this.offset;
    for (; !this.done && t.from < r; )
      t.to >= e && t.enter(r, 1, k.IgnoreOverlays | k.ExcludeBuffers) || t.next(!1) || (this.done = !0);
  }
  hasNode(e) {
    if (this.moveTo(e.from), !this.done && this.cursor.from + this.offset == e.from && this.cursor.tree)
      for (let t = this.cursor.tree; ; ) {
        if (t == e.tree)
          return !0;
        if (t.children.length && t.positions[0] == 0 && t.children[0] instanceof B)
          t = t.children[0];
        else
          break;
      }
    return !1;
  }
}
class Be {
  constructor(e) {
    var t;
    if (this.fragments = e, this.curTo = 0, this.fragI = 0, e.length) {
      let r = this.curFrag = e[0];
      this.curTo = (t = r.tree.prop(ee)) !== null && t !== void 0 ? t : r.to, this.inner = new ae(r.tree, -r.offset);
    } else
      this.curFrag = this.inner = null;
  }
  hasNode(e) {
    for (; this.curFrag && e.from >= this.curTo; )
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= e.from && this.curTo >= e.to && this.inner.hasNode(e);
  }
  nextFrag() {
    var e;
    if (this.fragI++, this.fragI == this.fragments.length)
      this.curFrag = this.inner = null;
    else {
      let t = this.curFrag = this.fragments[this.fragI];
      this.curTo = (e = t.tree.prop(ee)) !== null && e !== void 0 ? e : t.to, this.inner = new ae(t.tree, -t.offset);
    }
  }
  findMounts(e, t) {
    var r;
    let i = [];
    if (this.inner) {
      this.inner.cursor.moveTo(e, 1);
      for (let n = this.inner.cursor.node; n; n = n.parent) {
        let s = (r = n.tree) === null || r === void 0 ? void 0 : r.prop(C.mounted);
        if (s && s.parser == t)
          for (let h = this.fragI; h < this.fragments.length; h++) {
            let f = this.fragments[h];
            if (f.from >= n.to)
              break;
            f.tree == this.curFrag.tree && i.push({
              frag: f,
              pos: n.from - f.offset,
              mount: s
            });
          }
      }
    }
    return i;
  }
}
function pe(l, e) {
  let t = null, r = e;
  for (let i = 1, n = 0; i < l.length; i++) {
    let s = l[i - 1].to, h = l[i].from;
    for (; n < r.length; n++) {
      let f = r[n];
      if (f.from >= h)
        break;
      f.to <= s || (t || (r = t = e.slice()), f.from < s ? (t[n] = new z(f.from, s), f.to > h && t.splice(n + 1, 0, new z(h, f.to))) : f.to > h ? t[n--] = new z(h, f.to) : t.splice(n--, 1));
    }
  }
  return r;
}
function Ie(l, e, t, r) {
  let i = 0, n = 0, s = !1, h = !1, f = -1e9, u = [];
  for (; ; ) {
    let o = i == l.length ? 1e9 : s ? l[i].to : l[i].from, c = n == e.length ? 1e9 : h ? e[n].to : e[n].from;
    if (s != h) {
      let a = Math.max(f, t), x = Math.min(o, c, r);
      a < x && u.push(new z(a, x));
    }
    if (f = Math.min(o, c), f == 1e9)
      break;
    o == f && (s ? (s = !1, i++) : s = !0), c == f && (h ? (h = !1, n++) : h = !0);
  }
  return u;
}
function ce(l, e) {
  let t = [];
  for (let { pos: r, mount: i, frag: n } of l) {
    let s = r + (i.overlay ? i.overlay[0].from : 0), h = s + i.tree.length, f = Math.max(n.from, s), u = Math.min(n.to, h);
    if (i.overlay) {
      let o = i.overlay.map((a) => new z(a.from + r, a.to + r)), c = Ie(e, o, f, u);
      for (let a = 0, x = f; ; a++) {
        let d = a == c.length, _ = d ? u : c[a].from;
        if (_ > x && t.push(new q(x, _, i.tree, -s, n.from >= x || n.openStart, n.to <= _ || n.openEnd)), d)
          break;
        x = c[a].to;
      }
    } else
      t.push(new q(f, u, i.tree, -s, n.from >= s || n.openStart, n.to <= h || n.openEnd));
  }
  return t;
}
export {
  ze as DefaultBufferLength,
  k as IterMode,
  G as MountedTree,
  C as NodeProp,
  de as NodeSet,
  T as NodeType,
  Me as NodeWeakMap,
  Ee as Parser,
  B as Tree,
  U as TreeBuffer,
  Y as TreeCursor,
  q as TreeFragment,
  Te as parseMixed
};
